import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import './ComponentHeader.css';

class ComponentHeader extends React.Component {
  renderHeaderTooltip = tooltipMessage => (
    <Tooltip id="component-header-tooltip">{tooltipMessage}</Tooltip>
  );

  renderWrappedTitle = (tooltip = '', title) =>
    tooltip ? (
      <Fragment>
        <h3 className="tvt-component-header__title tvt-component-header__title--with-tooltip">
          {title}
        </h3>
        <OverlayTrigger
          placement="top"
          overlay={this.renderHeaderTooltip(tooltip)}
        >
          <i className="tvt-component-header__title-tooltip fa fa-info-circle" />
        </OverlayTrigger>
      </Fragment>
    ) : (
      <h3 className="tvt-component-header__title">{title}</h3>
    );

  render() {
    return (
      <div className="tvt-component-header">
        {this.renderWrappedTitle(this.props.tooltip, this.props.title)}
        {this.props.children}
      </div>
    );
  }
}

ComponentHeader.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])
    .isRequired,
  tooltip: PropTypes.string
};

ComponentHeader.defaultProps = {
  children: null,
  tooltip: ''
};

export default ComponentHeader;
